import React from 'react';
import css from "./SecTwo.module.scss";
import {brandingTypes} from "../../../../Utils/services/branding/brandingTypes";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const SecTwo = () => {

    const {t} = useTranslation();

    return (
        <section className={css.two}>
            <div className={css.main}>
                <div className={css.text}>
                    <p>{t("brandingServTwoHeader")} <span>{t("brandingServTwoHeaderSpan")}</span></p>
                </div>
                <div className={css.types}>
                    {
                        brandingTypes.map(({id, type, arrow})=>{
                            return(
                                <Link
                                    key={id}
                                    className={css.type}
                                >
                                    <div className={css.arrow}>
                                        {arrow}
                                    </div>
                                    <p>
                                        {t(type)}
                                    </p>
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    );
};

export default SecTwo;